// extracted by mini-css-extract-plugin
export default {"excahnge":"Exchange_excahnge__dnAG3","boxInput":"Exchange_boxInput__zrY-b","boxCur":"Exchange_boxCur__xtqWG"};